import { render, staticRenderFns } from "./TitleEditor.vue?vue&type=template&id=5a8373a0&scoped=true&"
import script from "./TitleEditor.vue?vue&type=script&lang=js&"
export * from "./TitleEditor.vue?vue&type=script&lang=js&"
import style0 from "./TitleEditor.vue?vue&type=style&index=0&id=5a8373a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8373a0",
  null
  
)

export default component.exports